import React from 'react'
import './MenuSubCategory.css'
import Footer from '../../component/Footer/Footer';
import LayoutWrapper from '../../component/LayoutWrapper/';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { menuCategory, doMenuCategoryRes } from '../../action/MenuCategoryAction';
import { categoryListSub, doSubCatListByCategoryRes } from '../../action/SubCatListByCategoryAction';
import { showAltText, doAltTextRes } from '../../action/AltTextAction';
import loaderImg from '../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';



class MenuSubCategory extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            menuCategoryList: [],
            isLoader: false,
            cat_id: props.match.params.id,
            subcategoryData: [],
            altData: '',
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount() {
        const altData = {}
        const data = {
            cat_id: this.state.cat_id
        }
        this.props.categoryListSub(data)
        this.props.showAltText(altData)
    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.doSubCatListByCategoryRes && nextProps.doSubCatListByCategoryRes.user) {
            if (nextProps.doSubCatListByCategoryRes.user && nextProps.doSubCatListByCategoryRes.user.subCatListByCategoryRes) {
                if (nextProps.doSubCatListByCategoryRes.user.subCatListByCategoryRes && nextProps.doSubCatListByCategoryRes.user.subCatListByCategoryRes.result === true) {
                    this.setState({
                        subcategoryData: nextProps.doSubCatListByCategoryRes.user.subCatListByCategoryRes.subcategory
                    })
                }
            }
        }

        if (nextProps.doMenuCategoryRes && nextProps.doMenuCategoryRes.user) {
            if (nextProps.doMenuCategoryRes.user && nextProps.doMenuCategoryRes.user.MenuCategoryRes) {
                if (nextProps.doMenuCategoryRes.user.MenuCategoryRes && nextProps.doMenuCategoryRes.user.MenuCategoryRes.result === true) {
                    this.setState({
                        menuCategoryList: nextProps.doMenuCategoryRes.user.MenuCategoryRes.category,
                        isLoader: false
                    })
                } else {
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if (nextProps.doAltTextRes && nextProps.doAltTextRes.user) {
            if (nextProps.doAltTextRes.user && nextProps.doAltTextRes.user.AltTextRes) {
                if (nextProps.doAltTextRes.user.AltTextRes && nextProps.doAltTextRes.user.AltTextRes.result === true) {
                    this.setState({
                        altData: nextProps.doAltTextRes.user.AltTextRes.data
                    })
                }
            }
        }
    }

    productDetails = (item) => {
        this.props.history.push('/product/' + item.cat_id + '/' + item.sub_id + '/' + item.slug, {
            sub_id: item.sub_id,
            cat_id: item.cat_id,
        })
        if (item.type === "customize") {
            // window.location.href =  '/productcupcustomize/'+item.product_id
            if (item.sub_id === "10") {
                this.props.history.push('/productcustomize/' + item.cat_id + '/' + item.sub_id + '/' + item.slug)
            }
            if (item.sub_id === "14") {
                this.props.history.push('/productmobilecustomize/' + item.cat_id + '/' + item.sub_id + '/' + item.slug)
            }
            if (item.sub_id === '11') {
                this.props.history.push('/productwomencustomize/' + item.cat_id + '/' + item.sub_id + '/' + item.slug)
            }
            if (item.sub_id === '17') {
                this.props.history.push('/productkidscustomize/' + item.cat_id + '/' + item.sub_id + '/' + item.slug)
            }

        }
    }

    manMenu = (manItem) => {
        if (manItem.sub_cat.length === 0) {
            window.location.href = '/product/' + manItem.id + '/0/' + manItem.slug

            this.props.history.push('/product/' + manItem.id + '/0/' + manItem.slug, {
                sub_id: 0,
                cat_id: manItem.id
            })
        }
    }

    subMenu = (subItem) => {
        window.location.href = '/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
        this.props.history.push('/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug, {
            sub_id: subItem.sub_id,
            cat_id: subItem.cat_id
        })
        if (subItem.type === "customize") {
            if (subItem.sub_id === "10") {
                window.location.href = '/productcustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === "14") {
                window.location.href = '/productmobilecustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '11') {
                window.location.href = '/productwomencustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '17') {
                window.location.href = '/productkidscustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
        }

    }

    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        return (
            <div className="page-wrapper">
                <LayoutWrapper />
                <Loader show={this.state.isLoader} message={spinner}>
                    <main className="main main-container">
                        {/* <div className="banner banner-cat bg-img">
                            <div className="banner-content container">
                                <h2 className="banner-subtitle">check out over <span>200+</span></h2>
                                <h1 className="banner-title">
                                    INCREDIBLE deals
                                </h1>
                                <a href="/" className="btn btn-primary">Shop Now</a>
                            </div>
                            End .banner-content
                        </div> */}
                        {/* End .banners */}
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    <li className="breadcrumb-item"><Link to={'#'}>Product</Link></li>
                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9">
                                    <div className="row row-sm"  >
                                        {this.state.subcategoryData && this.state.subcategoryData.map((item, i) => (
                                            <div className="col-6 col-md-4 col-xl-3" key={i}>
                                                <div className="product-default">
                                                    <figure>
                                                        <div className="pointer img-wdth img-product-height" title={this.state.altData} aria-label={this.state.altData} onClick={() => this.productDetails(item)} style={{ "backgroundImage": 'url(' + item.image + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
                                                    </figure>

                                                    <div className="product-details">
                                                        <h2 className="product-title">
                                                            <span className="product-name pointer" onClick={() => this.productDetails(item)} >{item.name}</span>
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {/* End .col-xl-3 */}
                                    </div>
                                </div>
                                {/* End .col-lg-9 */}
                                <aside className="sidebar-shop col-lg-3 order-lg-first">
                                    <div className="sidebar-wrapper">
                                        {
                                            this.state.menuCategoryList && this.state.menuCategoryList.map((item, i) => (
                                                <div className="widget" key={i}>
                                                    <h3 className="widget-title">
                                                        <div className={item.sub_cat.length > 0 ? "main-menu" : "main-cursor-menu "} data-toggle="collapse" role="button" aria-expanded="true" aria-controls="widget-body-2" onClick={() => this.manMenu(item)}>{item.cat_name}</div>
                                                    </h3>
                                                    {item.sub_cat.length > 0 &&

                                                        <div className="collapse show" id="widget-body-2">
                                                            <div className="widget-body">
                                                                <ul className="cat-list">
                                                                    {item.sub_cat.map((subItem, s) => (
                                                                        <li key={s}>
                                                                            <div className="sub-menu" onClick={() => this.subMenu(subItem, item.cat_name)}>{subItem.name}</div>
                                                                        </li>
                                                                    ))}

                                                                </ul>
                                                            </div>
                                                        </div>}
                                                </div>))}

                                    </div>
                                </aside>

                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}

                        <div className="mb-5"></div>
                        {/* margin */}
                    </main>
                </Loader>
                {/* End .main */}
                <Footer />

            </div>
        )


    }
}

MenuSubCategory.propTypes = {
    doSubCatListByCategoryRes: PropTypes.any,
    doMenuCategoryRes: PropTypes.any,
    doAltTextRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doSubCatListByCategoryRes: doSubCatListByCategoryRes,
    doMenuCategoryRes: doMenuCategoryRes,
    doAltTextRes: doAltTextRes,
});

function mapDispatchToProps(dispatch) {
    return {
        categoryListSub: (data) => dispatch(categoryListSub(data)),
        menuCategory: (data) => dispatch(menuCategory(data)),
        showAltText: (data) => dispatch(showAltText(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(MenuSubCategory)
